import {
  create_empty_declaration_form,
  declaration_rating_class,
  declaration_status_class
} from './conflicts_data';
import { declaration_drawer_catalog } from './conflicts_drawer';

function increment_card_value(card) {
  if (!card) return;
  const current_value = Number.parseInt(Reflect.get(card, 'value'), 10);
  if (!Number.isNaN(current_value)) Reflect.set(card, 'value', String(current_value + 1));
}

function validate_new_declaration_form(form) {
  if (!form.person.trim()) return 'Person is required.';
  if (!form.role.trim()) return 'Role is required.';
  if (!form.nature.trim()) return 'Nature of interest is required.';
  return '';
}

function build_declaration_row(ref, form) {
  const status_label = form.status;
  const declaration_row = {
    ref,
    person: form.person.trim(),
    role: form.role.trim(),
    department: form.department.trim() || '-',
    type: form.type,
    related_party: form.related_party.trim() || '-',
    rating: form.rating,
    status: { label: status_label, class: declaration_status_class(status_label) }
  };
  return declaration_row;
}

function build_declaration_drawer(form, status_label) {
  const declared_date = form.declared_date.trim() || 'Today';
  const person_name = form.person.trim();
  const declaration_drawer = {
    declared_date,
    nature: form.nature.trim(),
    assessment: null,
    show_workflow: status_label !== 'Outstanding',
    connected_records: [{ type: 'Person', title: person_name }],
    mitigation_actions: [],
    recusals: [],
    restrictions: [],
    evidence: [{ label: 'Declaration form', tag: 'FORM' }],
    activity: [{ title: 'Declaration submitted', actor: person_name, date: declared_date }]
  };
  return declaration_drawer;
}

function update_declaration_cards(cards, rating, status_label) {
  increment_card_value(Reflect.get(cards, 0));
  if (['Low', 'Medium', 'High', 'Critical'].includes(rating)) {
    increment_card_value(Reflect.get(cards, 1));
  }
  if (['High', 'Critical'].includes(rating)) {
    increment_card_value(Reflect.get(cards, 2));
  }
  if (status_label === 'Outstanding') {
    increment_card_value(Reflect.get(cards, 3));
  }
}

export const conflict_methods = {
  set_tab(tab_id) {
    this.active_tab = tab_id;
    this.close_declaration_drawer();
  },
  open_new_declaration_modal() {
    this.close_declaration_drawer();
    this.new_declaration_error = '';
    this.new_declaration_form = create_empty_declaration_form();
    this.show_new_declaration_modal = true;
  },
  close_new_declaration_modal() {
    this.show_new_declaration_modal = false;
    this.new_declaration_error = '';
  },
  next_declaration_reference() {
    const next_number = this.register_rows.reduce((highest, row) => {
      const parsed = Number.parseInt(String(row.ref).replace('COI-', ''), 10);
      return Number.isNaN(parsed) ? highest : Math.max(highest, parsed);
    }, 0) + 1;
    return `COI-${String(next_number).padStart(2, '0')}`;
  },
  create_new_declaration() {
    const validation_error = validate_new_declaration_form(this.new_declaration_form);
    if (validation_error) {
      this.new_declaration_error = validation_error;
      return;
    }

    const new_ref = this.next_declaration_reference();
    const new_status = this.new_declaration_form.status;
    const declaration_row = build_declaration_row(new_ref, this.new_declaration_form);
    const declaration_drawer = build_declaration_drawer(this.new_declaration_form, new_status);

    this.register_rows.unshift(declaration_row);
    Reflect.set(declaration_drawer_catalog, new_ref, declaration_drawer);

    const register_tab = this.tabs.find((tab) => tab.id === 'register');
    if (register_tab && typeof register_tab.count === 'number') register_tab.count += 1;
    update_declaration_cards(this.register_cards, this.new_declaration_form.rating, new_status);

    this.close_new_declaration_modal();
  },
  declaration_status_chip_class(label) {
    return declaration_status_class(label) || 'bg-light text-secondary border border-light';
  },
  declaration_rating_chip_class(rating) {
    return declaration_rating_class(rating) || 'bg-light text-secondary border border-light';
  }
};
